import * as i0 from '@angular/core';
import { Injectable, Directive, Input, NgModule } from '@angular/core';

class CitadelStylesService {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStylesService, deps: [], target: i0.ɵɵFactoryTarget.Injectable }); }
    static { this.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStylesService, providedIn: 'root' }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStylesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }] });

class CitadelRoundedDirective {
    constructor(renderer, el) {
        this.citadelRounded = 'large';
        renderer.addClass(el.nativeElement, `ds-rounding-${this.citadelRounded}`);
    }
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelRoundedDirective, deps: [{ token: i0.Renderer2 }, { token: i0.ElementRef }], target: i0.ɵɵFactoryTarget.Directive }); }
    static { this.ɵdir = i0.ɵɵngDeclareDirective({ minVersion: "14.0.0", version: "17.3.12", type: CitadelRoundedDirective, selector: "[citadelRounded]", inputs: { citadelRounded: "citadelRounded" }, ngImport: i0 }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelRoundedDirective, decorators: [{
            type: Directive,
            args: [{
                    selector: '[citadelRounded]'
                }]
        }], ctorParameters: () => [{ type: i0.Renderer2 }, { type: i0.ElementRef }], propDecorators: { citadelRounded: [{
                type: Input
            }] } });

class CitadelStylesModule {
    static { this.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStylesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule }); }
    static { this.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "17.3.12", ngImport: i0, type: CitadelStylesModule, declarations: [CitadelRoundedDirective], exports: [CitadelRoundedDirective] }); }
    static { this.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStylesModule }); }
}
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "17.3.12", ngImport: i0, type: CitadelStylesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        CitadelRoundedDirective
                    ],
                    imports: [],
                    exports: [
                        CitadelRoundedDirective
                    ]
                }]
        }] });

/*
 * Public API Surface of citadel-styles
 */

/**
 * Generated bundle index. Do not edit.
 */

export { CitadelRoundedDirective, CitadelStylesModule, CitadelStylesService };
